import { render, staticRenderFns } from "./ProfileUpdateRequestPage.vue?vue&type=template&id=a59eac8a"
import script from "./ProfileUpdateRequestPage.vue?vue&type=script&lang=js"
export * from "./ProfileUpdateRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports